import { render, staticRenderFns } from "./pendingrequest.vue?vue&type=template&id=96628264"
import script from "./pendingrequest.vue?vue&type=script&lang=js"
export * from "./pendingrequest.vue?vue&type=script&lang=js"
import style0 from "./pendingrequest.vue?vue&type=style&index=0&id=96628264&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports